import { render, staticRenderFns } from "./LgFinderPageClasse.vue?vue&type=template&id=14ff5455"
import script from "./LgFinderPageClasse.vue?vue&type=script&lang=js"
export * from "./LgFinderPageClasse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports